import { render, staticRenderFns } from "./BasketStandingOrders.vue?vue&type=template&id=079fe080&scoped=true&"
import script from "./BasketStandingOrders.vue?vue&type=script&lang=js&"
export * from "./BasketStandingOrders.vue?vue&type=script&lang=js&"
import style0 from "./BasketStandingOrders.vue?vue&type=style&index=0&id=079fe080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079fe080",
  null
  
)

export default component.exports